import { apiClient } from '@/libs/axios';
import { toMeDTO, type MeDTO } from '../schemas/get-me.schema';

export const getMe = async (): Promise<MeDTO> => {
  const response = await apiClient.get('auth/me');

  return toMeDTO(response);
};
